<template>
	<AppDialog v-model="isOpen" @close="onClose">
		<div style="width: 40vw">
            <div class="modal-header tw-mb-2 tw-px-5 tw-pb-4 tw-pt-5 border-bottom-1">
                <div>
                    <p class="tw-text-xl tw-font-semibold tw-text-gray-900">
                        {{ $t('filters') }}
                    </p>
                </div>
                <div>
                    <span class="cursor-pointer " @click="close()">
                        <InlineSvg
                            :src="loadFile('close.svg')"
                            class="tw-text-gray-500"
                        />
					</span>
                </div>
            </div>
			<AppForm ref="form" class="tw-p-5" @submit="onSubmit">
                <AppSelect
                    :label="$t('whatsapp.labels')"
                    v-model="filters.labels"
                    :options="labelsOptions"
                    :placeholder="$t('whatsapp.select-labels')"
                    multiple
                    optionLabel="name"
                    optionValue="id"
                />

				<div class="tw-mt-4 tw-flex tw-justify-end tw-gap-2">
					<AppButton
						type="button"
						@click="$refs.form.submit()"
						:label="$t('apply')"
						size="lg"
					/>
					<AppButton
						:label="$t('clear-all')"
						size="lg"
						secondary
						variant="gray"
						@click="clearAll"
					/>
				</div>
			</AppForm>
		</div>
	</AppDialog>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useLabelStore } from '@/v2/modules/whatsapp/stores/labels';
import AppDialog from '@/v2/components/dialog.vue';
import { loadFile } from '@/components/utils.js';
import InlineSvg from '@/v2/components/inline-svg';
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['success']);

const labelStore = useLabelStore();
const FAILED_TEMPLATE_LABEL_ID = '$FAILED_TEMPLATE$';
const { locale } = useI18n();

const isOpen = ref(false);
const filters = ref({
    labels: []
});

const labelsOptions = computed(() => {
    const failedTemplateLabelName = locale.value === 'ar' ? 'فشل قالب' : 'Failed Template';
    const options = [...(labelStore.list || [])].map((label) => {
        if (label?.id === FAILED_TEMPLATE_LABEL_ID) {
            return {
                ...label,
                name: failedTemplateLabelName,
            };
        }

        return label;
    });
    const hasFailedTemplateLabel = options.some((label) => label?.id === FAILED_TEMPLATE_LABEL_ID);

    if (!hasFailedTemplateLabel) {
        options.push({
            id: FAILED_TEMPLATE_LABEL_ID,
            name: failedTemplateLabelName,
        });
    }

    return options;
});

const open = () => {
	isOpen.value = true;
};

const close = () => {
	isOpen.value = false;
};

const onClose = () => {};

const onConfirm = () => {
	isOpen.value = false;
};

const onSubmit = async () => {
    emit('applyFilters', filters.value);
    close();
};
const clearAll = async () => {
    filters.value["labels"] = [];
    emit('applyFilters', filters.value);
    close();
};

onUnmounted(() => {

});

defineExpose({
	open,
});
</script>

<style lang="scss" scoped>
@import 'tailwindcss/base';
@import 'tailwindcss/utilities';
</style>
